export default __webpack_public_path__ + "static/media/911.ac262f89.png";